import { connect } from 'react-redux';

import { State } from 'store/types';
import SwitchView from './Switch';

const mapStateToProps = (state: State) => {
  const { remoteConfig } = state;
  return {
    inlinePRConfig: remoteConfig.configs.pdPriceReveal,
  };
};

export default connect(mapStateToProps)(SwitchView);
